<template>
    <section class="business-trends">
        <title-date-component :titleOption="titleOption" :initDateRange="initDateRange" @changeDate="changeDate" @changeCompareDate="changeCompareDate"></title-date-component>
        <section class="data-box">
            <nav-component :type="type" :currentType="currentType" @changeNavType="changeNavType"></nav-component>
            <line-component style="width:95%; height:320px; margin-top:50px;" :resultData="resultData"></line-component>
        </section>
    </section>
</template>

<style lang="scss" scoped="scoped">
    .business-trends {
        background-color: #FFF;
	    padding: 30px 20px 10px 20px;
        margin-top: 20px;
        .data-box {
            width: 100%;
            height: 400px;
            padding-left: 15px;
            margin-top: 35px;
        }
    }
</style>

<script>
    import TitleDateComponent from '../../../components/title-date/TitleDate.vue'
    import NavComponent from '../../../components/nav/Nav.vue'
    import LineComponent from '../../../components/echarts/Line.vue'
    import DataPlatform from 'api/dataPlatform'
    import MomentFormat from '../../../filters/moment-format'

    export default {
        components: {
            TitleDateComponent,
	        NavComponent,
	        LineComponent
        },
        data () {
            const data = {
                titleOption: {  // 单元块名称和日期选择配置
                    title: '经营趋势',  // 名称
                    dateRadio: false,    // 是否显示昨天、本周、本月日期单选框
                    dateRangeSelect: true, // 是否显示日期区间下拉框
	                dateCompareSelect: true,
                    download: true, // 是否显示下载按钮
	                moduleId: 3,
	                bizCode: this.bizCode,
	                showDate: {
		                startDate: MomentFormat.getSevenDate(),
		                endDate: MomentFormat.getYestoday()
	                }
                },
                type: [
                    {
                    	name: '销量',
                        value: 'payQuantity'
                    },
	                {
		                name: '销售额',
		                value: 'payAmt'
	                },
	                {
		                name: '浏览量',
		                value: 'intentionPv'
	                },
	                {
		                name: '访客量',
		                value: 'intentionUv'
	                },
	                {
		                name: '访购率',
		                value: 'purchaseRate'
	                },
	                {
		                name: '下单用户数',
		                value: 'orderUserNum'
	                },
	                {
		                name: '支付用户数',
		                value: 'payUserNum'
	                },
	                {
		                name: '客单价',
		                value: 'unitPrice'
	                }
                ],
                currentType: 'payQuantity', // 当前纬度
	            startDate: MomentFormat.getSevenDate(),  // 开始日期
	            endDate: MomentFormat.getYestoday(), // 结束日期
	            initDateRange: MomentFormat.getSevenDate() + ' ~ ' + MomentFormat.getYestoday(),
                typeData: {
	                allTypeData: {  // 所有维度数据
		                payQuantity: [],
		                payAmt: [],
		                intentionPv: [],
		                intentionUv: [],
		                purchaseRate: [],
		                orderUserNum: [],
		                payUserNum: [],
		                unitPrice: []
	                },
	                allTypeCompareData: {   // 所有对比纬度数据
		                payQuantity: [],
		                payAmt: [],
		                intentionPv: [],
		                intentionUv: [],
		                purchaseRate: [],
		                orderUserNum: [],
		                payUserNum: [],
		                unitPrice: []
	                }
                },
                resultData: {
                	dateArr: [],
                    dataArr: [],
                    dateCompareArr: [],     // 对比日期
                    dataCompareArr: [],     // 对比数据
	                currentTypeName: '销量'
                }
            };
            return data;
        },
        props: ["bizCode"],
        methods: {
        	// 获取经营趋势数据
	        getOperationTrendData () {
		        DataPlatform.getOperationTrendData(this.bizCode, this.startDate, this.endDate, this.titleOption.moduleId)
                    .then((res) => {
                        console.log(res);
                        if (res.status === 0) {
                        	let data = res.data;
                        	let date = [];
	                        let initData = {
		                        payQuantity: [],
                                payAmt: [],
                                intentionPv: [],
                                intentionUv: [],
                                purchaseRate: [],
                                orderUserNum: [],
                                payUserNum: [],
                                unitPrice: []
	                        };
                        	data.forEach((item, index) => {
                        		date.push(item.date);
		                        initData.payQuantity.push(item.payQuantity);
		                        initData.payAmt.push(item.payAmt);
		                        initData.intentionPv.push(item.intentionPv);
		                        initData.intentionUv.push(item.intentionUv);
		                        initData.purchaseRate.push(item.purchaseRate);
		                        initData.orderUserNum.push(item.orderUserNum);
		                        initData.payUserNum.push(item.payUserNum);
		                        initData.unitPrice.push(item.unitPrice);
                            });
	                        this.typeData.allTypeData = initData;
                        	this.$set(this.resultData, 'dateArr', date);
	                        this.$set(this.resultData, 'dataArr', this.typeData.allTypeData[this.currentType]);
                        } else {
                            this.$notify.error({
                                title: '错误',
                                message: res.message || '请求失败'
                            })
                        }
                    })
                    .catch((err) => {
		        	    this.resultData.dateArr = [];
	                    this.resultData.dataArr = [];
                        console.log(err);
                    })
            },

            // 切换类型
	        changeNavType (type) {
	        	this.currentType = type;
	        	let currentTypeName = this.type.find((item) => {
	        		return item.value === this.currentType;
                });
		        this.$set(this.resultData, 'dataArr', this.typeData.allTypeData[this.currentType]);
		        this.$set(this.resultData, 'dataCompareArr', this.typeData.allTypeCompareData[this.currentType]);
		        this.$set(this.resultData, 'currentTypeName', currentTypeName.name);
            },

	        // 切换日期
	        changeDate (params) {
		        this.startDate = params.dateRange.startDate;
		        this.endDate = params.dateRange.endDate;
		        this.getOperationTrendData();
	        },

            // 切换对比日期
	        changeCompareDate (params) {
	        	if (params.dateRange.startDate === '' || params.dateRange.endDate === '') {
			        this.resultData.dateCompareArr = [];
			        this.resultData.dataCompareArr = [];
	        		return;
                }
		        DataPlatform.getOperationTrendData(this.bizCode, params.dateRange.startDate, params.dateRange.endDate, this.titleOption.moduleId)
                    .then((res) => {
                        console.log(res);
                        if (res.status === 0) {
                            let data = res.data;
                            let date = [];
	                        let initData = {
		                        payQuantity: [],
		                        payAmt: [],
		                        intentionPv: [],
		                        intentionUv: [],
		                        purchaseRate: [],
		                        orderUserNum: [],
		                        payUserNum: [],
		                        unitPrice: []
	                        };
                            data.forEach((item, index) => {
                                date.push(item.date);
	                            initData.payQuantity.push(item.payQuantity);
	                            initData.payAmt.push(item.payAmt);
	                            initData.intentionPv.push(item.intentionPv);
	                            initData.intentionUv.push(item.intentionUv);
	                            initData.purchaseRate.push(item.purchaseRate);
	                            initData.orderUserNum.push(item.orderUserNum);
	                            initData.payUserNum.push(item.payUserNum);
	                            initData.unitPrice.push(item.unitPrice);
                            });
	                        this.typeData.allTypeCompareData = initData;
                            this.$set(this.resultData, 'dateCompareArr', date);
                            this.$set(this.resultData, 'dataCompareArr', this.typeData.allTypeCompareData[this.currentType]);
                        } else {
                            this.$notify.error({
                                title: '错误',
                                message: res.message || '请求失败'
                            })
                        }
                    })
                    .catch((err) => {
                        this.resultData.dateCompareArr = [];
                        this.resultData.dataCompareArr = [];
                        console.log(err);
                    })
            }
        },
	    mounted () {
        	this.getOperationTrendData();
        }
    }
</script>



// WEBPACK FOOTER //
// BusinessTrends.vue?669931ea